export default {
  // NOTE: name is singular
  name: 'sampleLifeEventCategory',
  uniqKey: '_id',
  crudMapping: {
    readMany: 'sampleLifeEventCategories',
    readOne: 'sampleLifeEventCategory',
    update: 'updateSampleLifeEventCategory',
  },
  readManySchema: {
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Life Event Category',
      type: 'object',
      required: ['title', 'sampleLifeEventThemeIds'],
      properties: {
        title: {
          type: 'string',
        },
        sampleLifeEventThemeIds: {
          type: 'array',
          default: [],
          items: {
            type: 'string',
          },
          title: 'Associated Sample Life Event Themes',
        },
      },
    },
    uiSchema: {
      sampleLifeEventThemeIds: {
        'ui:field': 'hasManyField',
        'ui:options': {
          sortable: true,
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/sampleLifeEventCategory.js